import React from 'react';
import NexusAssistant from './NexusAssistant';

function App() {
  return <NexusAssistant />;
}

export default App;